module.exports = __webpack_public_path__ + "static/media/wheel_dis.7a08bc06.png";